/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** ActivateOrchestratorRequest */
export interface ActivateOrchestratorRequest {
    /**
     * Agents
     * Roster sub-agent IDs the orchestrator delegates to
     */
    agents: string[];
    /**
     * Organization
     * Org tag; defaults to the caller's token org
     */
    organization?: string | null;
    /** Apikeysecret */
    apiKeySecret?: string | null;
}

/** ActivateOrchestratorResponse */
export interface ActivateOrchestratorResponse {
    /** Agentid */
    agentId: string;
    /** Version */
    version: number;
    /** Rosterchanged */
    rosterChanged: boolean;
    /** Agents */
    agents: string[];
    /** Organization */
    organization?: string | null;
    /** Environmentid */
    environmentId?: string | null;
    /** Vaultid */
    vaultId?: string | null;
    /** Apikeysecret */
    apiKeySecret?: string | null;
}

/** AgentConfigResponse */
export interface AgentConfigResponse {
    /** Id */
    id: string;
    /** Name */
    name?: string | null;
    /** Modelid */
    modelId?: string | null;
    /** Modelspeed */
    modelSpeed?: string | null;
    /** Modeleffort */
    modelEffort?: string | null;
    /** Description */
    description?: string | null;
    /** System */
    system?: string | null;
    /** Organization */
    organization?: string | null;
    /** Iscoordinator */
    isCoordinator: boolean;
    /** Agents */
    agents: string[];
    /** Version */
    version: number;
    /** Builtintools */
    builtinTools?: Record<string, Record<string, any>>;
    /** Mcpservers */
    mcpServers?: Record<string, any>[];
}

/** AgentFullConfigResponse */
export interface AgentFullConfigResponse {
    /** Agentid */
    agentId: string;
    /** Name */
    name: string;
    /** Description */
    description?: string | null;
    /** Modelid */
    modelId?: string | null;
    /** Modelspeed */
    modelSpeed?: string | null;
    /** Modeleffort */
    modelEffort?: string | null;
    /** System */
    system: string;
    /** Organization */
    organization?: string | null;
    /** Builtintools */
    builtinTools: Record<string, BuiltinToolState>;
    /** Mcpservers */
    mcpServers: McpServerState[];
    /** Skills */
    skills: SkillState[];
}

/** AgentInformation */
export interface AgentInformation {
    /** Mcpservernames */
    mcpServerNames: string[];
    /** Description */
    description?: string | null;
    /** Builtintools */
    builtinTools?: Record<string, boolean>;
}

/** AgentListItem */
export interface AgentListItem {
    /** Id */
    id: string;
    /** Name */
    name?: string | null;
    /** Model */
    model?: string | null;
    /** Organization */
    organization?: string | null;
    /** Iscoordinator */
    isCoordinator: boolean;
    /** Iscomplete */
    isComplete: boolean;
}

/**
 * AgentModel
 * Model representing an AI agent/model configuration
 */
export interface AgentModel {
    /** Name */
    Name: string;
    /** Model */
    Model: string;
    /** Modelcompany */
    ModelCompany: string;
    /** Organization */
    Organization: string;
    /** Apikey */
    ApiKey?: string | null;
    /** Description */
    Description?: string | null;
    /** Environmentid */
    EnvironmentId?: string | null;
    /** Vaultid */
    VaultId?: string | null;
    /** Anthropicapikey */
    AnthropicApiKey?: string | null;
    /** Version */
    Version?: number | null;
    /** Subagentroster */
    SubAgentRoster?: string[] | null;
    /** Enablerls */
    EnableRls?: boolean | null;
}

/** AgentRequest */
export interface AgentRequest {
    /** The agent/model configuration the current user should use. */
    agent: AgentModel;
}

/** AgentSaveResponse */
export interface AgentSaveResponse {
    /** Agentid */
    agentId: string;
    /** Version */
    version: number;
}

/** AgentVersionItem */
export interface AgentVersionItem {
    /** Version */
    version: number;
    /** Name */
    name: string;
    /** Createdat */
    createdAt?: string | null;
    /** Updatedat */
    updatedAt?: string | null;
}

/** AssignThreadToFolderRequest */
export interface AssignThreadToFolderRequest {
    /** Thread Id */
    thread_id: string;
    /** Folder Id */
    folder_id?: string;
}

/** Body_uploadReferenceFile */
export interface BodyUploadReferenceFile {
    /**
     * File
     * @format binary
     */
    file: File;
    /** Apikeysecret */
    apiKeySecret?: string | null;
}

/** BuiltinToolConfig */
export interface BuiltinToolConfig {
    /**
     * Enabled
     * @default false
     */
    enabled?: boolean;
    /**
     * Auto
     * @default true
     */
    auto?: boolean;
}

/** BuiltinToolState */
export interface BuiltinToolState {
    /** Enabled */
    enabled: boolean;
    /** Auto */
    auto: boolean;
}

/** CreateAgentRequest */
export interface CreateAgentRequest {
    /** Name */
    name: string;
    /** Modelid */
    modelId: string;
    /**
     * Modelspeed
     * 'standard' or 'fast'
     */
    modelSpeed?: string | null;
    /**
     * Modeleffort
     * Extended-thinking depth: 'low', 'medium', 'high', 'xhigh', or 'max'
     */
    modelEffort?: string | null;
    /** System */
    system: string;
    /** Description */
    description: string;
    /** Organization */
    organization?: string | null;
    /** Builtintools */
    builtinTools?: Record<string, BuiltinToolConfig>;
    /** Mcpservers */
    mcpServers?: McpServerConfig[];
    /** Skills */
    skills?: SkillConfig[];
    /** Apikeysecret */
    apiKeySecret?: string | null;
}

/** CreateCoordinatorRequest */
export interface CreateCoordinatorRequest {
    /** Name */
    name: string;
    /** Modelid */
    modelId: string;
    /** Modelspeed */
    modelSpeed?: string | null;
    /** Modeleffort */
    modelEffort?: string | null;
    /** Description */
    description?: string | null;
    /** System */
    system?: string | null;
    /**
     * Agents
     * Initial roster sub-agent IDs
     */
    agents?: string[];
    /** Organization */
    organization?: string | null;
    /** Apikeysecret */
    apiKeySecret?: string | null;
    /** Builtintools */
    builtinTools?: Record<string, BuiltinToolConfig>;
    /** Mcpservers */
    mcpServers?: McpServerConfig[];
}

/** CreateCoordinatorResponse */
export interface CreateCoordinatorResponse {
    /** Agentid */
    agentId: string;
    /** Version */
    version: number;
}

/** CreateFolderRequest */
export interface CreateFolderRequest {
    /** Name */
    name: string;
    /** Parent Folder Id */
    parent_folder_id?: string | null;
}

/** CreateMemoryFileRequest */
export interface CreateMemoryFileRequest {
    /** Path */
    path: string;
    /** Apikeysecret */
    apiKeySecret?: string | null;
}

/** CreateMemoryStoreRequest */
export interface CreateMemoryStoreRequest {
    /** Name */
    name: string;
    /** Description */
    description?: string | null;
    /** Apikeysecret */
    apiKeySecret?: string | null;
}

/** DeleteFolderRequest */
export interface DeleteFolderRequest {
    /** Folder Id */
    folder_id: string;
}

/** FoldersListResponse */
export interface FoldersListResponse {
    /** Folders */
    folders: ProjectFolder[];
    /** Assignments */
    assignments: ThreadFolderAssignment[];
}

/** GeneratePodcastRequest */
export interface GeneratePodcastRequest {
    /** Thread Id */
    thread_id: string;
}

/** HTTPValidationError */
export interface HTTPValidationError {
    /** Detail */
    detail?: ValidationError[];
}

/** MCPResourceRequest */
export interface MCPResourceRequest {
    /** Resource Uri */
    resource_uri: string;
    /** Server Name */
    server_name?: string | null;
    /** Server Url */
    server_url?: string | null;
}

/** MCPResourceResponse */
export interface MCPResourceResponse {
    /** Content */
    content: string;
    /** Content Type */
    content_type: string;
    /** Mime Type */
    mime_type?: string | null;
}

/** MCPServerModel */
export interface MCPServerModel {
    /** Name */
    Name: string;
    /** Displayname */
    DisplayName: string;
    /** Description */
    Description: string;
    /** Internalurl */
    InternalUrl: string;
    /** Externalurl */
    ExternalUrl: string;
    /** Transporttype */
    TransportType: string;
    /** Organization */
    Organization: string;
    /** Configtype */
    ConfigType: string;
    /** Sourcelink */
    SourceLink?: string | null;
}

/** McpServerConfig */
export interface McpServerConfig {
    /** Name */
    name: string;
    /** Url */
    url: string;
    /**
     * Auto
     * @default true
     */
    auto?: boolean;
}

/** McpServerState */
export interface McpServerState {
    /** Name */
    name: string;
    /** Url */
    url: string;
    /** Auto */
    auto: boolean;
}

/** MemoryFileDetail */
export interface MemoryFileDetail {
    /** Id */
    id: string;
    /** Path */
    path: string;
    /** Content */
    content: string;
    /** Content Size Bytes */
    content_size_bytes: number;
}

/** MemoryFileItem */
export interface MemoryFileItem {
    /** Id */
    id: string;
    /** Path */
    path: string;
}

/** ModelItem */
export interface ModelItem {
    /** Id */
    id: string;
    /** Display Name */
    display_name: string;
    /** Supports Effort */
    supports_effort?: boolean;
    /** Effort Levels */
    effort_levels?: string[];
}

/**
 * OrganizationsResponse
 * Response containing list of organizations
 */
export interface OrganizationsResponse {
    /**
     * Organizations
     * List of organizations the user belongs to
     */
    organizations: Record<string, any>[];
    /**
     * Message
     * Optional message about the organizations
     */
    message?: string | null;
}

/** PodcastAuthorizationResponse */
export interface PodcastAuthorizationResponse {
    /** Authorized */
    authorized: boolean;
    /** Reason */
    reason?: string | null;
}

/** PodcastGeneratedResponse */
export interface PodcastGeneratedResponse {
    /** Success */
    success: boolean;
    /** Podcast Url */
    podcast_url: string;
    /** Thread Id */
    thread_id: string;
    /**
     * Is Outdated
     * @default false
     */
    is_outdated?: boolean;
    /** Created At */
    created_at: string;
    /** Last Message At */
    last_message_at: string;
    /** Size Bytes */
    size_bytes?: number | null;
    /** Podcast Name */
    podcast_name?: string | null;
    /**
     * File Extension
     * @default "mp3"
     */
    file_extension?: string;
}

/** PodcastStatusResponse */
export interface PodcastStatusResponse {
    /** Has Podcast */
    has_podcast: boolean;
    /**
     * Is Outdated
     * @default false
     */
    is_outdated?: boolean;
    /** Podcast Url */
    podcast_url?: string | null;
    /** Created At */
    created_at?: string | null;
    /** Last Message At */
    last_message_at?: string | null;
    /** Current Last Message At */
    current_last_message_at?: string | null;
    /** Size Bytes */
    size_bytes?: number | null;
    /**
     * File Extension
     * @default "mp3"
     */
    file_extension?: string;
    /** Podcast Name */
    podcast_name?: string | null;
}

/** ProjectFolder */
export interface ProjectFolder {
    /** Id */
    id: string;
    /** Name */
    name: string;
    /** Userid */
    userId: string;
    /** Parentid */
    parentId?: string | null;
    /** Level */
    level: number;
    /** Expanded */
    expanded: boolean;
    /** Createdat */
    createdAt: string;
}

/** ReferenceFileItem */
export interface ReferenceFileItem {
    /** Id */
    id: string;
    /** Filename */
    filename: string;
}

/**
 * SelectOrganizationRequest
 * Request to select an organization
 */
export interface SelectOrganizationRequest {
    /**
     * Organizationid
     * Organization ID to select
     */
    organizationId: string;
    /**
     * Organizationname
     * Organization name
     */
    organizationName: string;
    /**
     * Organizationalias
     * Organization alias (if available)
     */
    organizationAlias?: string | null;
}

/**
 * SelectOrganizationResponse
 * Response after selecting an organization
 */
export interface SelectOrganizationResponse {
    /**
     * Success
     * Whether the organization was selected successfully
     */
    success: boolean;
    /**
     * Organizationid
     * Organization ID
     */
    organizationId: string;
    /**
     * Organizationname
     * Organization name
     */
    organizationName: string;
    /**
     * Redirecturl
     * URL to redirect to for completing organization selection
     */
    redirectUrl?: string | null;
    /**
     * Message
     * Optional message
     */
    message?: string | null;
}

/** SelectableResource */
export interface SelectableResource {
    /** Id */
    id: string;
    /** Name */
    name: string;
    /** Organization */
    organization?: string | null;
}

/** ServersRequest */
export interface ServersRequest {
    /**
     * Servers
     * List of MCP servers the current user should use. Overwrites any previous selection.
     */
    servers: MCPServerModel[];
}

/**
 * SetAgentResponse
 * Response body for setting agent on a user.
 */
export interface SetAgentResponse {
    /**
     * Status
     * Operation status, 'ok' on success
     */
    status: string;
    /**
     * User Key
     * Stable user identifier derived from auth claims
     */
    user_key: string;
    /** The agent now configured for the user */
    agent: AgentModel;
}

/**
 * SetServersResponse
 * Response body for setting MCP servers on a user.
 */
export interface SetServersResponse {
    /**
     * Status
     * Operation status, 'ok' on success
     */
    status: string;
    /**
     * User Key
     * Stable user identifier derived from auth claims
     */
    user_key: string;
    /**
     * Servers
     * The servers now configured for the user
     */
    servers: MCPServerModel[];
}

/**
 * SetSystemPromptResponse
 * Response body for setting system prompt on a user.
 */
export interface SetSystemPromptResponse {
    /**
     * Status
     * Operation status, 'ok' on success
     */
    status: string;
    /**
     * User Key
     * Stable user identifier derived from auth claims
     */
    user_key: string;
    /**
     * Guid
     * The system prompt guid now configured for the user
     */
    guid: string;
}

/** SkillConfig */
export interface SkillConfig {
    /** Skill Id */
    skill_id: string;
    /**
     * Source
     * @default "anthropic"
     */
    source?: string;
}

/** SkillItem */
export interface SkillItem {
    /** Skill Id */
    skill_id: string;
    /** Display Title */
    display_title: string;
    /** Source */
    source: string;
}

/** SkillState */
export interface SkillState {
    /** Skill Id */
    skill_id: string;
    /** Source */
    source: string;
}

/** SuccessResponse */
export interface SuccessResponse {
    /** Success */
    success: boolean;
}

/** SystemPromptRequest */
export interface SystemPromptRequest {
    /**
     * Guid
     * The guid of the system prompt the current user should use.
     */
    guid: string;
}

/** ThreadFolderAssignment */
export interface ThreadFolderAssignment {
    /** Threadid */
    threadId: string;
    /** Folderid */
    folderId: string;
}

/** UpdateAgentConfigRequest */
export interface UpdateAgentConfigRequest {
    /** Name */
    name?: string | null;
    /** Modelid */
    modelId?: string | null;
    /** Modelspeed */
    modelSpeed?: string | null;
    /** Modeleffort */
    modelEffort?: string | null;
    /** Description */
    description?: string | null;
    /** System */
    system?: string | null;
    /**
     * Agents
     * Roster sub-agent IDs
     */
    agents?: string[] | null;
    /** Organization */
    organization?: string | null;
    /** Apikeysecret */
    apiKeySecret?: string | null;
    /** Builtintools */
    builtinTools?: Record<string, BuiltinToolConfig> | null;
    /** Mcpservers */
    mcpServers?: McpServerConfig[] | null;
}

/** UpdateAgentRequest */
export interface UpdateAgentRequest {
    /** Name */
    name?: string | null;
    /** Modelid */
    modelId?: string | null;
    /** Modelspeed */
    modelSpeed?: string | null;
    /** Modeleffort */
    modelEffort?: string | null;
    /** System */
    system?: string | null;
    /** Description */
    description?: string | null;
    /** Organization */
    organization?: string | null;
    /** Builtintools */
    builtinTools?: Record<string, BuiltinToolConfig> | null;
    /** Mcpservers */
    mcpServers?: McpServerConfig[] | null;
    /** Skills */
    skills?: SkillConfig[] | null;
    /** Apikeysecret */
    apiKeySecret?: string | null;
}

/** UpdateFolderRequest */
export interface UpdateFolderRequest {
    /** Folder Id */
    folder_id: string;
    /** Name */
    name: string;
    /** Parent Id */
    parent_id?: string | null;
    /** Expanded */
    expanded?: boolean | null;
}

/** UpdateMemoryFileRequest */
export interface UpdateMemoryFileRequest {
    /** Content */
    content: string;
    /** Apikeysecret */
    apiKeySecret?: string | null;
}

/**
 * UsageTrackingRequest
 * Request model for usage tracking.
 */
export interface UsageTrackingRequest {
    /**
     * Sourceapp
     * Source application name
     */
    SourceApp: string;
    /**
     * Subject
     * Subject of the usage event
     */
    Subject: string;
    /**
     * Action
     * Action performed
     */
    Action: string;
    /**
     * Type
     * Event type (0=Usage, 1=Audit)
     */
    Type: number;
    /**
     * Properties
     * Additional properties
     */
    Properties?: Record<string, string> | null;
}

/**
 * UsageTrackingResponse
 * Response model for usage tracking.
 */
export interface UsageTrackingResponse {
    /**
     * Success
     * Whether tracking was successful
     */
    success: boolean;
    /**
     * Message
     * Optional message
     */
    message?: string | null;
}

/** ValidationError */
export interface ValidationError {
    /** Location */
    loc: (string | number)[];
    /** Message */
    msg: string;
    /** Error Type */
    type: string;
}

/** VaultCredentialItem */
export interface VaultCredentialItem {
    /** Credentialid */
    credentialId: string;
    /** Displayname */
    displayName: string;
    /** Mcpserverurl */
    mcpServerUrl: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean;
    /** request path */
    path: string;
    /** content type of request body */
    type?: ContentType;
    /** query params */
    query?: QueryParamsType;
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseFormat;
    /** request body */
    body?: unknown;
    /** base url */
    baseUrl?: string;
    /** request cancellation token */
    cancelToken?: CancelToken;
}

export type RequestParams = Omit<
    FullRequestParams,
    'body' | 'method' | 'query' | 'path'
>;

export interface ApiConfig<SecurityDataType = unknown> {
    baseUrl?: string;
    baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
    securityWorker?: (
        securityData: SecurityDataType | null
    ) => Promise<RequestParams | void> | RequestParams | void;
    customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
    extends Response {
    data: D;
    error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
    Json = 'application/json',
    JsonApi = 'application/vnd.api+json',
    FormData = 'multipart/form-data',
    UrlEncoded = 'application/x-www-form-urlencoded',
    Text = 'text/plain'
}

export class HttpClient<SecurityDataType = unknown> {
    public baseUrl: string = import.meta.env.VITE_APP_API_BASE_URL || '';
    private securityData: SecurityDataType | null = null;
    private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
    private abortControllers = new Map<CancelToken, AbortController>();
    private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
        fetch(...fetchParams);

    private baseApiParams: RequestParams = {
        credentials: 'same-origin',
        headers: {},
        redirect: 'follow',
        referrerPolicy: 'no-referrer'
    };

    constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
        Object.assign(this, apiConfig);
    }

    public setSecurityData = (data: SecurityDataType | null) => {
        this.securityData = data;
    };

    protected encodeQueryParam(key: string, value: any) {
        const encodedKey = encodeURIComponent(key);
        return `${encodedKey}=${encodeURIComponent(
            typeof value === 'number' ? value : `${value}`
        )}`;
    }

    protected addQueryParam(query: QueryParamsType, key: string) {
        return this.encodeQueryParam(key, query[key]);
    }

    protected addArrayQueryParam(query: QueryParamsType, key: string) {
        const value = query[key];
        return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
    }

    protected toQueryString(rawQuery?: QueryParamsType): string {
        const query = rawQuery || {};
        const keys = Object.keys(query).filter(
            (key) => 'undefined' !== typeof query[key]
        );
        return keys
            .map((key) =>
                Array.isArray(query[key])
                    ? this.addArrayQueryParam(query, key)
                    : this.addQueryParam(query, key)
            )
            .join('&');
    }

    protected addQueryParams(rawQuery?: QueryParamsType): string {
        const queryString = this.toQueryString(rawQuery);
        return queryString ? `?${queryString}` : '';
    }

    private contentFormatters: Record<ContentType, (input: any) => any> = {
        [ContentType.Json]: (input: any) =>
            input !== null &&
            (typeof input === 'object' || typeof input === 'string')
                ? JSON.stringify(input)
                : input,
        [ContentType.JsonApi]: (input: any) =>
            input !== null &&
            (typeof input === 'object' || typeof input === 'string')
                ? JSON.stringify(input)
                : input,
        [ContentType.Text]: (input: any) =>
            input !== null && typeof input !== 'string'
                ? JSON.stringify(input)
                : input,
        [ContentType.FormData]: (input: any) => {
            if (input instanceof FormData) {
                return input;
            }

            return Object.keys(input || {}).reduce((formData, key) => {
                const property = input[key];
                formData.append(
                    key,
                    property instanceof Blob
                        ? property
                        : typeof property === 'object' && property !== null
                        ? JSON.stringify(property)
                        : `${property}`
                );
                return formData;
            }, new FormData());
        },
        [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input)
    };

    protected mergeRequestParams(
        params1: RequestParams,
        params2?: RequestParams
    ): RequestParams {
        return {
            ...this.baseApiParams,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.baseApiParams.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {})
            }
        };
    }

    protected createAbortSignal = (
        cancelToken: CancelToken
    ): AbortSignal | undefined => {
        if (this.abortControllers.has(cancelToken)) {
            const abortController = this.abortControllers.get(cancelToken);
            if (abortController) {
                return abortController.signal;
            }
            return void 0;
        }

        const abortController = new AbortController();
        this.abortControllers.set(cancelToken, abortController);
        return abortController.signal;
    };

    public abortRequest = (cancelToken: CancelToken) => {
        const abortController = this.abortControllers.get(cancelToken);

        if (abortController) {
            abortController.abort();
            this.abortControllers.delete(cancelToken);
        }
    };

    public request = async <T = any, E = any>({
        body,
        secure,
        path,
        type,
        query,
        format,
        baseUrl,
        cancelToken,
        ...params
    }: FullRequestParams): Promise<HttpResponse<T, E>> => {
        const secureParams =
            ((typeof secure === 'boolean'
                ? secure
                : this.baseApiParams.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const queryString = query && this.toQueryString(query);
        const payloadFormatter =
            this.contentFormatters[type || ContentType.Json];
        const responseFormat = format || requestParams.format;

        return this.customFetch(
            `${baseUrl || this.baseUrl || ''}${path}${
                queryString ? `?${queryString}` : ''
            }`,
            {
                ...requestParams,
                headers: {
                    ...(requestParams.headers || {}),
                    ...(type && type !== ContentType.FormData
                        ? { 'Content-Type': type }
                        : {})
                },
                signal:
                    (cancelToken
                        ? this.createAbortSignal(cancelToken)
                        : requestParams.signal) || null,
                body:
                    typeof body === 'undefined' || body === null
                        ? null
                        : payloadFormatter(body)
            }
        ).then(async (response) => {
            const r = response as HttpResponse<T, E>;
            r.data = null as unknown as T;
            r.error = null as unknown as E;

            const data = !responseFormat
                ? r
                : await response[responseFormat]()
                      .then((data) => {
                          if (r.ok) {
                              r.data = data;
                          } else {
                              r.error = data;
                          }
                          return r;
                      })
                      .catch((e) => {
                          r.error = e;
                          return r;
                      });

            if (cancelToken) {
                this.abortControllers.delete(cancelToken);
            }

            if (!response.ok) throw data;
            return data;
        });
    };
}

/**
 * @title FastAPI
 * @version 0.1.0
 */
export class AppApi<
    SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
    health = {
        /**
         * No description
         *
         * @name HealthCheckHealthGet
         * @summary Health Check
         * @request GET:/health
         */
        healthCheckHealthGet: (params: RequestParams = {}) =>
            this.request<any, any>({
                path: `/health`,
                method: 'GET',
                format: 'json',
                ...params
            })
    };
    mcp = {
        /**
         * @description Provide the list of MCP servers that the current user should use. This overwrites any previous selection for this user.
         *
         * @tags MCP
         * @name SetMcpServersOnUser
         * @summary Set selected MCP servers for current user
         * @request POST:/mcp/set-servers
         * @secure
         */
        setMcpServersOnUser: (
            data: ServersRequest,
            params: RequestParams = {}
        ) =>
            this.request<SetServersResponse, HTTPValidationError>({
                path: `/mcp/set-servers`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Returns the list of MCP servers previously set for the current user. Returns an empty array if none have been set.
         *
         * @tags MCP
         * @name GetMcpServersOnUser
         * @summary Get selected MCP servers for current user
         * @request GET:/mcp/get-servers
         * @secure
         */
        getMcpServersOnUser: (params: RequestParams = {}) =>
            this.request<MCPServerModel[], any>({
                path: `/mcp/get-servers`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Fetches content for an MCP resource URI. Uses the user's existing MCP server connections.
         *
         * @tags MCP
         * @name FetchMcpResource
         * @summary Fetch MCP resource content
         * @request POST:/mcp/resource
         * @secure
         */
        fetchMcpResource: (
            data: MCPResourceRequest,
            params: RequestParams = {}
        ) =>
            this.request<MCPResourceResponse, HTTPValidationError>({
                path: `/mcp/resource`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            })
    };
    agent = {
        /**
         * @description Provide the agent/model configuration that the current user should use. This overwrites any previous selection for this user.
         *
         * @tags Agent
         * @name SetAgentOnUser
         * @summary Set selected agent/model for current user
         * @request POST:/agent/set-agent
         * @secure
         */
        setAgentOnUser: (data: AgentRequest, params: RequestParams = {}) =>
            this.request<SetAgentResponse, HTTPValidationError>({
                path: `/agent/set-agent`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Returns the agent/model configuration previously set for the current user. Returns null if none has been set.
         *
         * @tags Agent
         * @name GetAgentOnUser
         * @summary Get selected agent/model for current user
         * @request GET:/agent/get-agent
         * @secure
         */
        getAgentOnUser: (params: RequestParams = {}) =>
            this.request<AgentModel | null, any>({
                path: `/agent/get-agent`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            })
    };
    systemPrompt = {
        /**
         * @description Provide the system prompt guid that the current user should use. This overwrites any previous selection for this user.
         *
         * @tags SystemPrompt
         * @name SetSystemPromptOnUser
         * @summary Set selected system prompt for current user
         * @request POST:/system-prompt/set-prompt
         * @secure
         */
        setSystemPromptOnUser: (
            data: SystemPromptRequest,
            params: RequestParams = {}
        ) =>
            this.request<SetSystemPromptResponse, HTTPValidationError>({
                path: `/system-prompt/set-prompt`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Returns the system prompt guid previously set for the current user. Returns null if none has been set.
         *
         * @tags SystemPrompt
         * @name GetSystemPromptOnUser
         * @summary Get selected system prompt guid for current user
         * @request GET:/system-prompt/get-prompt
         * @secure
         */
        getSystemPromptOnUser: (params: RequestParams = {}) =>
            this.request<string | null, any>({
                path: `/system-prompt/get-prompt`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            })
    };
    auth = {
        /**
         * @description Get list of organizations for a user who belongs to multiple organizations. This endpoint is called when a user has no 'organization' claim in their token. Requires the user to be authenticated.
         *
         * @tags Organization
         * @name GetUserOrganizations
         * @summary Get organizations for current user
         * @request GET:/auth/organizations
         * @secure
         */
        getUserOrganizations: (params: RequestParams = {}) =>
            this.request<OrganizationsResponse, any>({
                path: `/auth/organizations`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Select an organization using token exchange. Exchanges the current access token for a new one with the organization claim.
         *
         * @tags Organization
         * @name SelectOrganization
         * @summary Select an organization
         * @request POST:/auth/select-organization
         * @secure
         */
        selectOrganization: (
            data: SelectOrganizationRequest,
            params: RequestParams = {}
        ) =>
            this.request<SelectOrganizationResponse, HTTPValidationError>({
                path: `/auth/select-organization`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            })
    };
    project = {
        /**
         * @description List all folders and thread assignments for the current user's organization.
         *
         * @tags Project Folders
         * @name ListFoldersProjectFoldersGet
         * @summary List all folders for the current user
         * @request GET:/project/folders
         * @secure
         */
        listFoldersProjectFoldersGet: (params: RequestParams = {}) =>
            this.request<FoldersListResponse, any>({
                path: `/project/folders`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Update folder name, parent, or expanded state.
         *
         * @tags Project Folders
         * @name UpdateFolderProjectFoldersPut
         * @summary Update a folder
         * @request PUT:/project/folders
         * @secure
         */
        updateFolderProjectFoldersPut: (
            data: UpdateFolderRequest,
            params: RequestParams = {}
        ) =>
            this.request<SuccessResponse, HTTPValidationError>({
                path: `/project/folders`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Create a new folder with optional parent folder in the user's organization.
         *
         * @tags Project Folders
         * @name CreateFolderProjectFoldersPost
         * @summary Create a new folder
         * @request POST:/project/folders
         * @secure
         */
        createFolderProjectFoldersPost: (
            data: CreateFolderRequest,
            params: RequestParams = {}
        ) =>
            this.request<ProjectFolder, HTTPValidationError>({
                path: `/project/folders`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Delete a folder and all its subfolders. Thread assignments are removed.
         *
         * @tags Project Folders
         * @name DeleteFolderProjectFoldersDelete
         * @summary Delete a folder
         * @request DELETE:/project/folders
         * @secure
         */
        deleteFolderProjectFoldersDelete: (
            data: DeleteFolderRequest,
            params: RequestParams = {}
        ) =>
            this.request<SuccessResponse, HTTPValidationError>({
                path: `/project/folders`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Assign a thread to a folder or unassign from all folders (if folderId is None).
         *
         * @tags Project Folders
         * @name AssignThreadToFolderProjectThreadFolderAssignmentPost
         * @summary Assign thread to folder
         * @request POST:/project/thread-folder-assignment
         * @secure
         */
        assignThreadToFolderProjectThreadFolderAssignmentPost: (
            data: AssignThreadToFolderRequest,
            params: RequestParams = {}
        ) =>
            this.request<SuccessResponse, HTTPValidationError>({
                path: `/project/thread-folder-assignment`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            })
    };
    podcast = {
        /**
         * @description Check if the current user is authorized to use the podcast feature. Requires podcast to be enabled for the organization.
         *
         * @tags Podcast
         * @name CheckPodcastAuthorizationPodcastAuthorizedGet
         * @summary Check if user is authorized to use podcast feature
         * @request GET:/podcast/authorized
         * @secure
         */
        checkPodcastAuthorizationPodcastAuthorizedGet: (
            params: RequestParams = {}
        ) =>
            this.request<PodcastAuthorizationResponse, any>({
                path: `/podcast/authorized`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Get the podcast status for a thread. Returns whether a podcast exists, if it's outdated, and the URL if available.
         *
         * @tags Podcast
         * @name GetPodcastStatusPodcastStatusThreadIdGet
         * @summary Get podcast status for a thread
         * @request GET:/podcast/status/{thread_id}
         * @secure
         */
        getPodcastStatusPodcastStatusThreadIdGet: (
            threadId: string,
            params: RequestParams = {}
        ) =>
            this.request<PodcastStatusResponse, HTTPValidationError>({
                path: `/podcast/status/${threadId}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Download the podcast audio file for a thread. Supports HTTP Range requests for seeking in audio players.
         *
         * @tags Podcast
         * @name DownloadPodcastEndpointPodcastDownloadThreadIdGet
         * @summary Download podcast audio for a thread
         * @request GET:/podcast/download/{thread_id}
         * @secure
         */
        downloadPodcastEndpointPodcastDownloadThreadIdGet: (
            threadId: string,
            params: RequestParams = {}
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/podcast/download/${threadId}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Delete the podcast for a thread.
         *
         * @tags Podcast
         * @name DeletePodcastEndpointPodcastDeleteThreadIdDelete
         * @summary Delete podcast for a thread
         * @request DELETE:/podcast/delete/{thread_id}
         * @secure
         */
        deletePodcastEndpointPodcastDeleteThreadIdDelete: (
            threadId: string,
            params: RequestParams = {}
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/podcast/delete/${threadId}`,
                method: 'DELETE',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Cancel an ongoing podcast generation for a thread.
         *
         * @tags Podcast
         * @name CancelPodcastGenerationPodcastCancelThreadIdPost
         * @summary Cancel ongoing podcast generation
         * @request POST:/podcast/cancel/{thread_id}
         * @secure
         */
        cancelPodcastGenerationPodcastCancelThreadIdPost: (
            threadId: string,
            params: RequestParams = {}
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/podcast/cancel/${threadId}`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Generate a podcast MP3 from thread messages using Azure OpenAI + Azure Speech. Natural two-host format. Uploads to Azure Blob Storage. Returns JSON with podcast URL and metadata instead of streaming the file. Supports cancellation via /cancel/{thread_id} endpoint or client disconnect.
         *
         * @tags Podcast
         * @name GeneratePodcastPodcastGeneratePost
         * @summary Generate a podcast from thread content
         * @request POST:/podcast/generate
         * @secure
         */
        generatePodcastPodcastGeneratePost: (
            data: GeneratePodcastRequest,
            params: RequestParams = {}
        ) =>
            this.request<PodcastGeneratedResponse, HTTPValidationError>({
                path: `/podcast/generate`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            })
    };
    api = {
        /**
         * @description Track a usage event by forwarding to the external usage service. This endpoint acts as a proxy, forwarding the usage tracking request to the configured usage service while automatically including the user's access token. Args: request: Usage tracking request data fastapi_request: The FastAPI request object to get token from current_user: Current authenticated user (injected by dependency) Returns: UsageTrackingResponse indicating success or failure Raises: HTTPException: If the external service is unreachable or returns an error
         *
         * @tags Usage Tracking
         * @name TrackUsageApiUsagePost
         * @summary Track usage event
         * @request POST:/api/usage
         * @secure
         */
        trackUsageApiUsagePost: (
            data: UsageTrackingRequest,
            params: RequestParams = {}
        ) =>
            this.request<UsageTrackingResponse, HTTPValidationError>({
                path: `/api/usage`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description List live Anthropic agents, org-filtered on `metadata.organization`. The org defaults to the caller's token org; an explicit `organization` query param overrides it (org match is always required — never returns other orgs' agents). `coordinatorsOnly=true` returns only agents tagged `metadata.type == "coordinator"` — this reflects INTENT (so admins can see coordinators that are missing a roster and need fixing), not whether `multiagent` is actually set. Use `isComplete` on each item to check whether it can actually delegate.
         *
         * @tags Coordinator Agents
         * @name ListAnthropicAgents
         * @summary List all live Anthropic agents (for picking a coordinator roster)
         * @request GET:/api/agents
         * @secure
         */
        listAnthropicAgents: (
            query?: {
                /** Apikeysecret */
                apiKeySecret?: string | null;
                /** Organization */
                organization?: string | null;
                /**
                 * Coordinatorsonly
                 * @default false
                 */
                coordinatorsOnly?: boolean;
            },
            params: RequestParams = {}
        ) =>
            this.request<AgentListItem[], HTTPValidationError>({
                path: `/api/agents`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Agents Admin
         * @name CreateAgent
         * @summary Create a new Claude Managed Agent
         * @request POST:/api/agents
         * @secure
         */
        createAgent: (data: CreateAgentRequest, params: RequestParams = {}) =>
            this.request<AgentSaveResponse, HTTPValidationError>({
                path: `/api/agents`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Creates the Anthropic-side agent itself — the caller (CoordinatorTab's "New Coordinator" flow) then registers the returned agentId in the mgmt DB. Previously the admin had to create a plain agent elsewhere first and paste its id in here; this endpoint removes that manual hand-off.
         *
         * @tags Coordinator Agents
         * @name CreateCoordinatorAgent
         * @summary Create a brand-new Anthropic agent tagged as a coordinator
         * @request POST:/api/agents/coordinator/create
         * @secure
         */
        createCoordinatorAgent: (
            data: CreateCoordinatorRequest,
            params: RequestParams = {}
        ) =>
            this.request<CreateCoordinatorResponse, HTTPValidationError>({
                path: `/api/agents/coordinator/create`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Coordinator Agents
         * @name GetAgentConfig
         * @summary Get a coordinator agent's full config (name, model, system, roster)
         * @request GET:/api/agents/{agent_id}
         * @secure
         */
        getAgentConfig: (
            agentId: string,
            query?: {
                /** Apikeysecret */
                apiKeySecret?: string | null;
            },
            params: RequestParams = {}
        ) =>
            this.request<AgentConfigResponse, HTTPValidationError>({
                path: `/api/agents/${agentId}`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Coordinator Agents
         * @name UpdateAgentConfig
         * @summary Update a coordinator agent's config (name, model, description, system, roster)
         * @request PUT:/api/agents/{agent_id}
         * @secure
         */
        updateAgentConfig: (
            agentId: string,
            data: UpdateAgentConfigRequest,
            params: RequestParams = {}
        ) =>
            this.request<AgentConfigResponse, HTTPValidationError>({
                path: `/api/agents/${agentId}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Agents Admin
         * @name ArchiveAgent
         * @summary Archive a Claude Managed Agent on Anthropic's side (there's no hard-delete)
         * @request DELETE:/api/agents/{agent_id}
         * @secure
         */
        archiveAgent: (
            agentId: string,
            query?: {
                /** Apikeysecret */
                apiKeySecret?: string | null;
            },
            params: RequestParams = {}
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/api/agents/${agentId}`,
                method: 'DELETE',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Thin HTTP wrapper — used by admin tooling/scripts. The chat flow itself no longer calls this: `ClaudeManagedFoundationStrategy.foundation()` calls `activate_orchestrator()` directly, inline, inside the existing "Preparation of agent" step.
         *
         * @tags Coordinator Agents
         * @name ActivateOrchestrator
         * @summary Activate the persistent per-org orchestrator with the given roster
         * @request POST:/api/agents/coordinator
         * @secure
         */
        activateOrchestrator: (
            data: ActivateOrchestratorRequest,
            params: RequestParams = {}
        ) =>
            this.request<ActivateOrchestratorResponse, HTTPValidationError>({
                path: `/api/agents/coordinator`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Agents Admin
         * @name UpdateAgentFullConfig
         * @summary Update a Claude Managed Agent's full config (model, tools, MCP servers, skills)
         * @request PUT:/api/agents/{agent_id}/full-config
         * @secure
         */
        updateAgentFullConfig: (
            agentId: string,
            data: UpdateAgentRequest,
            params: RequestParams = {}
        ) =>
            this.request<AgentSaveResponse, HTTPValidationError>({
                path: `/api/agents/${agentId}/full-config`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Agents Admin
         * @name GetAgentFullConfig
         * @summary Get a Claude Managed Agent's full config (model, tools, MCP servers, skills)
         * @request GET:/api/agents/{agent_id}/full-config
         * @secure
         */
        getAgentFullConfig: (
            agentId: string,
            query?: {
                /** Apikeysecret */
                apiKeySecret?: string | null;
            },
            params: RequestParams = {}
        ) =>
            this.request<AgentFullConfigResponse, HTTPValidationError>({
                path: `/api/agents/${agentId}/full-config`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Agents Admin
         * @name ListAgentVersions
         * @summary List an agent's version history, newest first
         * @request GET:/api/agents/{agent_id}/versions
         * @secure
         */
        listAgentVersions: (
            agentId: string,
            query?: {
                /** Apikeysecret */
                apiKeySecret?: string | null;
            },
            params: RequestParams = {}
        ) =>
            this.request<AgentVersionItem[], HTTPValidationError>({
                path: `/api/agents/${agentId}/versions`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Agents Admin
         * @name GetAgentInformation
         * @summary Get the names of the MCP servers configured on a specific agent, plus its description
         * @request GET:/api/agent_information/{agent_id}
         * @secure
         */
        getAgentInformation: (
            agentId: string,
            query?: {
                /** Apikeysecret */
                apiKeySecret?: string | null;
            },
            params: RequestParams = {}
        ) =>
            this.request<AgentInformation, HTTPValidationError>({
                path: `/api/agent_information/${agentId}`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Agents Admin
         * @name ListAvailableModels
         * @summary List available models visible to this API key, for the admin UI's model picker
         * @request GET:/api/models
         * @secure
         */
        listAvailableModels: (
            query?: {
                /** Apikeysecret */
                apiKeySecret?: string | null;
            },
            params: RequestParams = {}
        ) =>
            this.request<ModelItem[], HTTPValidationError>({
                path: `/api/models`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Agents Admin
         * @name ListAvailableSkills
         * @summary List available skills (Anthropic + custom) to attach to an agent
         * @request GET:/api/skills
         * @secure
         */
        listAvailableSkills: (
            query?: {
                /** Apikeysecret */
                apiKeySecret?: string | null;
            },
            params: RequestParams = {}
        ) =>
            this.request<SkillItem[], HTTPValidationError>({
                path: `/api/skills`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Agents Admin
         * @name ListEnvironments
         * @summary List all environments visible to this API key, for the admin UI to pick from
         * @request GET:/api/environments
         * @secure
         */
        listEnvironments: (
            query?: {
                /** Apikeysecret */
                apiKeySecret?: string | null;
            },
            params: RequestParams = {}
        ) =>
            this.request<SelectableResource[], HTTPValidationError>({
                path: `/api/environments`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Agents Admin
         * @name ListVaults
         * @summary List all vaults visible to this API key, for the admin UI to pick from
         * @request GET:/api/vaults
         * @secure
         */
        listVaults: (
            query?: {
                /** Apikeysecret */
                apiKeySecret?: string | null;
            },
            params: RequestParams = {}
        ) =>
            this.request<SelectableResource[], HTTPValidationError>({
                path: `/api/vaults`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Agents Admin
         * @name ListMemoryStores
         * @summary List all memory stores visible to this API key, for the Scheduled Agents wizard to pick from
         * @request GET:/api/memory-stores
         * @secure
         */
        listMemoryStores: (
            query?: {
                /** Apikeysecret */
                apiKeySecret?: string | null;
            },
            params: RequestParams = {}
        ) =>
            this.request<SelectableResource[], HTTPValidationError>({
                path: `/api/memory-stores`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Agents Admin
         * @name CreateMemoryStore
         * @summary Create a new memory store, for the Scheduled Agents wizard's inline create flow
         * @request POST:/api/memory-stores
         * @secure
         */
        createMemoryStore: (
            data: CreateMemoryStoreRequest,
            params: RequestParams = {}
        ) =>
            this.request<SelectableResource, HTTPValidationError>({
                path: `/api/memory-stores`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Agents Admin
         * @name DeleteMemoryStore
         * @summary Delete a memory store — irreversible, admin-only
         * @request DELETE:/api/memory-stores/{memory_store_id}
         * @secure
         */
        deleteMemoryStore: (
            memoryStoreId: string,
            query?: {
                /** Apikeysecret */
                apiKeySecret?: string | null;
            },
            params: RequestParams = {}
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/api/memory-stores/${memoryStoreId}`,
                method: 'DELETE',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Agents Admin
         * @name ListMemoryFiles
         * @summary List memory files already in a store, for the Scheduled Agents wizard to pick from
         * @request GET:/api/memory-stores/{memory_store_id}/memories
         * @secure
         */
        listMemoryFiles: (
            memoryStoreId: string,
            query?: {
                /** Apikeysecret */
                apiKeySecret?: string | null;
            },
            params: RequestParams = {}
        ) =>
            this.request<MemoryFileItem[], HTTPValidationError>({
                path: `/api/memory-stores/${memoryStoreId}/memories`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Agents Admin
         * @name CreateMemoryFile
         * @summary Create an empty memory file in a store, for the Scheduled Agents wizard's inline create flow
         * @request POST:/api/memory-stores/{memory_store_id}/memories
         * @secure
         */
        createMemoryFile: (
            memoryStoreId: string,
            data: CreateMemoryFileRequest,
            params: RequestParams = {}
        ) =>
            this.request<MemoryFileItem, HTTPValidationError>({
                path: `/api/memory-stores/${memoryStoreId}/memories`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Agents Admin
         * @name GetMemoryFile
         * @summary Get a memory file's full content, for the Claude Settings admin UI's view/edit dialog
         * @request GET:/api/memory-stores/{memory_store_id}/memories/{memory_id}
         * @secure
         */
        getMemoryFile: (
            memoryStoreId: string,
            memoryId: string,
            query?: {
                /** Apikeysecret */
                apiKeySecret?: string | null;
            },
            params: RequestParams = {}
        ) =>
            this.request<MemoryFileDetail, HTTPValidationError>({
                path: `/api/memory-stores/${memoryStoreId}/memories/${memoryId}`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Agents Admin
         * @name UpdateMemoryFile
         * @summary Overwrite a memory file's content, for the Claude Settings admin UI's edit-and-save flow
         * @request PUT:/api/memory-stores/{memory_store_id}/memories/{memory_id}
         * @secure
         */
        updateMemoryFile: (
            memoryStoreId: string,
            memoryId: string,
            data: UpdateMemoryFileRequest,
            params: RequestParams = {}
        ) =>
            this.request<MemoryFileDetail, HTTPValidationError>({
                path: `/api/memory-stores/${memoryStoreId}/memories/${memoryId}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Agents Admin
         * @name DeleteMemoryFile
         * @summary Delete a single memory file from a store, for the Claude Settings admin UI
         * @request DELETE:/api/memory-stores/{memory_store_id}/memories/{memory_id}
         * @secure
         */
        deleteMemoryFile: (
            memoryStoreId: string,
            memoryId: string,
            query?: {
                /** Apikeysecret */
                apiKeySecret?: string | null;
            },
            params: RequestParams = {}
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/api/memory-stores/${memoryStoreId}/memories/${memoryId}`,
                method: 'DELETE',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Agents Admin
         * @name UploadReferenceFile
         * @summary Upload a read-only reference file for a Deep Intelligence schedule
         * @request POST:/api/reference-files
         * @secure
         */
        uploadReferenceFile: (
            data: BodyUploadReferenceFile,
            params: RequestParams = {}
        ) =>
            this.request<ReferenceFileItem, HTTPValidationError>({
                path: `/api/reference-files`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Agents Admin
         * @name DeleteReferenceFile
         * @summary Delete a reference file — irreversible, admin-only
         * @request DELETE:/api/reference-files/{file_id}
         * @secure
         */
        deleteReferenceFile: (
            fileId: string,
            query?: {
                /** Apikeysecret */
                apiKeySecret?: string | null;
            },
            params: RequestParams = {}
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/api/reference-files/${fileId}`,
                method: 'DELETE',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags Agents Admin
         * @name ListVaultCredentials
         * @summary List the MCP servers a vault already has OAuth credentials for
         * @request GET:/api/vaults/{vault_id}/credentials
         * @secure
         */
        listVaultCredentials: (
            vaultId: string,
            query?: {
                /** Apikeysecret */
                apiKeySecret?: string | null;
            },
            params: RequestParams = {}
        ) =>
            this.request<VaultCredentialItem[], HTTPValidationError>({
                path: `/api/vaults/${vaultId}/credentials`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            })
    };
    mgmt = {
        /**
         * No description
         *
         * @name ProxyMgmtMgmtFullPathDelete
         * @summary Proxy Mgmt
         * @request DELETE:/mgmt/{full_path}
         */
        proxyMgmtMgmtFullPathDelete: (
            fullPath: string | null,
            params: RequestParams = {}
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/mgmt/${fullPath}`,
                method: 'DELETE',
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @name ProxyMgmtMgmtFullPathDelete2
         * @summary Proxy Mgmt
         * @request OPTIONS:/mgmt/{full_path}
         * @originalName proxyMgmtMgmtFullPathDelete
         * @duplicate
         */
        proxyMgmtMgmtFullPathDelete2: (
            fullPath: string | null,
            params: RequestParams = {}
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/mgmt/${fullPath}`,
                method: 'OPTIONS',
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @name ProxyMgmtMgmtFullPathDelete3
         * @summary Proxy Mgmt
         * @request PUT:/mgmt/{full_path}
         * @originalName proxyMgmtMgmtFullPathDelete
         * @duplicate
         */
        proxyMgmtMgmtFullPathDelete3: (
            fullPath: string | null,
            params: RequestParams = {}
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/mgmt/${fullPath}`,
                method: 'PUT',
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @name ProxyMgmtMgmtFullPathDelete4
         * @summary Proxy Mgmt
         * @request POST:/mgmt/{full_path}
         * @originalName proxyMgmtMgmtFullPathDelete
         * @duplicate
         */
        proxyMgmtMgmtFullPathDelete4: (
            fullPath: string | null,
            params: RequestParams = {}
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/mgmt/${fullPath}`,
                method: 'POST',
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @name ProxyMgmtMgmtFullPathDelete5
         * @summary Proxy Mgmt
         * @request PATCH:/mgmt/{full_path}
         * @originalName proxyMgmtMgmtFullPathDelete
         * @duplicate
         */
        proxyMgmtMgmtFullPathDelete5: (
            fullPath: string | null,
            params: RequestParams = {}
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/mgmt/${fullPath}`,
                method: 'PATCH',
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @name ProxyMgmtMgmtFullPathDelete6
         * @summary Proxy Mgmt
         * @request GET:/mgmt/{full_path}
         * @originalName proxyMgmtMgmtFullPathDelete
         * @duplicate
         */
        proxyMgmtMgmtFullPathDelete6: (
            fullPath: string | null,
            params: RequestParams = {}
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/mgmt/${fullPath}`,
                method: 'GET',
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @name ProxyMgmtMgmtDelete
         * @summary Proxy Mgmt
         * @request DELETE:/mgmt
         */
        proxyMgmtMgmtDelete: (
            query?: {
                /** Full Path */
                full_path?: string | null;
            },
            params: RequestParams = {}
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/mgmt`,
                method: 'DELETE',
                query: query,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @name ProxyMgmtMgmtDelete2
         * @summary Proxy Mgmt
         * @request OPTIONS:/mgmt
         * @originalName proxyMgmtMgmtDelete
         * @duplicate
         */
        proxyMgmtMgmtDelete2: (
            query?: {
                /** Full Path */
                full_path?: string | null;
            },
            params: RequestParams = {}
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/mgmt`,
                method: 'OPTIONS',
                query: query,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @name ProxyMgmtMgmtDelete3
         * @summary Proxy Mgmt
         * @request PUT:/mgmt
         * @originalName proxyMgmtMgmtDelete
         * @duplicate
         */
        proxyMgmtMgmtDelete3: (
            query?: {
                /** Full Path */
                full_path?: string | null;
            },
            params: RequestParams = {}
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/mgmt`,
                method: 'PUT',
                query: query,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @name ProxyMgmtMgmtDelete4
         * @summary Proxy Mgmt
         * @request POST:/mgmt
         * @originalName proxyMgmtMgmtDelete
         * @duplicate
         */
        proxyMgmtMgmtDelete4: (
            query?: {
                /** Full Path */
                full_path?: string | null;
            },
            params: RequestParams = {}
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/mgmt`,
                method: 'POST',
                query: query,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @name ProxyMgmtMgmtDelete5
         * @summary Proxy Mgmt
         * @request PATCH:/mgmt
         * @originalName proxyMgmtMgmtDelete
         * @duplicate
         */
        proxyMgmtMgmtDelete5: (
            query?: {
                /** Full Path */
                full_path?: string | null;
            },
            params: RequestParams = {}
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/mgmt`,
                method: 'PATCH',
                query: query,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @name ProxyMgmtMgmtDelete6
         * @summary Proxy Mgmt
         * @request GET:/mgmt
         * @originalName proxyMgmtMgmtDelete
         * @duplicate
         */
        proxyMgmtMgmtDelete6: (
            query?: {
                /** Full Path */
                full_path?: string | null;
            },
            params: RequestParams = {}
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/mgmt`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params
            })
    };
}
